import { axiosPostHandler } from './config'
import {extractAPIValues} from '_lib/utils/utils'
const { BASE_XHH } = extractAPIValues()
// 通过box_data获取token
export function getSMToken (formdata) {
	let url = BASE_XHH + '/rc/box_data/callback'
	return axiosPostHandler(url, {}, formdata)
}

// 测试lacktoken
// export function testLackToken (args) {
// 	let url = '/rc/test_lack_token'
// 	return axiosGetHandler(url, args)
// }